import { surfaceHoverClassName } from "@/components/ui/surface-contract";
import { cn } from "@/lib/cn";
import "@/components/ui/control-tooltip-motion.css";

/**
 * Shared style constants for the rail/header utility buttons — split out of
 * `app-utility-controls.tsx` so they can be reused by `rail-project-switcher.tsx`
 * without tripping `react-refresh/only-export-components` on the component file.
 */

export const utilityButtonClass = cn(
  surfaceHoverClassName(),
  "h-9 w-9 shrink-0 rounded-full border border-transparent bg-transparent text-muted transition-colors hover:text-primary focus-visible:ring-2",
);

export const verticalTooltipClass =
  "denker-glass-tooltip denker-control-tooltip pointer-events-none absolute left-full top-1/2 z-50 ml-3 -translate-y-1/2 whitespace-nowrap rounded-full border px-2.5 py-1 text-canvas-md font-medium";
